import { createAction, props } from '@ngrx/store';
import { WorkOrder } from '../work-order/work-order.model';

export const kudosGiven = createAction('[Kudos] Kudos Given', props<{ workOrder: WorkOrder }>());
